import { EditAvenantPage } from "@features/rh/contrats/components/avenants/EditAvenantPage";
import { requirePermission } from "@lib/permissions/guards";
import { PERMISSIONS } from "@lib/permissions/permissions.generated";
import { createFileRoute } from "@tanstack/react-router";
import { FilePen } from "lucide-react";

export const Route = createFileRoute("/_app/rh/contrats/$id/avenants/$avenantId/edit")({
  loader: requirePermission(PERMISSIONS.RH.AVENANTS.EDIT),
  staticData: {
    title: "Modifier un avenant",
    icon: FilePen,
    permission: PERMISSIONS.RH.AVENANTS.EDIT,
    section: "App",
    showInBreadcrumb: true,
  },
  component: EditAvenantPage,
});
